  <section id="geia-team" class="feature-medicine-section section-gap section-mt-mobile bg-grey" style="background:#F2F2F2; ">
  <div class="container"> 
    <div class="row justify-content-center align-items-center">
      <div class="col-lg-5 col-md-10 order-lg-last " >
        <div class="tile-gallery-three round box-shadow-4">
          <div class="image-one">
            <img src="../../../../assets/app-assets/images/ilustracao/team.png" alt="Image" />
          </div>
        </div>
      </div>
      <div class="col-lg-7 col-md-8 col-sm-10 mt-4 mt-blog-mobile">
        <div class="feature-content pr-xl-5 mt-md-50 mt-desktop-only">
          <div class="section-heading mt-5">
            <span class="subt-title-left span-30px">A Géia tem uma equipe </span>
            <h2 class="title-left" style="line-height: 1.1">de Gestão de saúde focada em você!</h2>
          </div>
          <p class="mt-1">

            Incentivando a promoção de saúde através de acompanhamento personalizado, dicas de alimentação e a
            prática
            de atividades físicas, proporcionando-lhes melhora da qualidade de vida.
          </p>
        </div>
      </div>

    </div>
  </div>


</section> 
 